import React from 'react';
import styles from './Button.module.scss'

const Button = (props) => {
    
    const { text, className, disabled, onClickHandle } = props

    const propsToStyles = (string, styles) => {

        const styleArray = [];
        string.split(" ").map((className) => styleArray.push(styles[className]));
        return styleArray.join(' ')
    }

    return (
        <button 
            className={`
                ${styles.button} 
                ${ disabled ? styles.disabled : '' }
                ${className ? propsToStyles(className, styles) : '' }     
            `} 
            disabled={disabled} 
            onClick={ onClickHandle }>
            {text}
        </button> 
    );
}
export default Button;